import { getApiRequestByUrl, loginRequest } from "../authConfig";
import axios from 'axios';

async function fetchToken(request) {
    if (!request.msalInstance) {
        throw new Error('No msalInstance provided. Unable to obtain token');
    }

    if (!request.account) {
        console.warn('No account provided. Triggering a login redirect');
        await request.msalInstance.loginRedirect(loginRequest);
    }

    let tokenRequest = null;
    let bearerToken = null;

    try {
        const apiRequest = getApiRequestByUrl(request.url);
        tokenRequest = {
            ...apiRequest,
            account: request.account,
        };
        const response = await request.msalInstance.acquireTokenSilent(tokenRequest);
        bearerToken = `Bearer ${response.accessToken}`;
    } catch (e) {
        if (e.name === 'InteractionRequiredAuthError') {
            if (tokenRequest) {
                return request.msalInstance.acquireTokenRedirect(tokenRequest);
            } 
            
            // no token request could be provided, forcing a general redirect                
            return request.msalInstance.loginRedirect(loginRequest);
        }

        throw Error(`Failed to authorize request for ${request.url}. ${e}`);
    }

    if (!bearerToken) {
        throw Error('Request not authorized. Something unexpected has occurred');
    }

    return bearerToken;
}

async function getAuthenticatedClient(request) {
    const bearerToken = await fetchToken(request);
    
    const headers = {
        Authorization: bearerToken,
        ...request.headers
    };
    
    if (request.contentType) {
        headers['Content-Type'] = request.contentType;
    }

    return axios({
        url: request.url,
        method: request.method,
        headers,
        params: request.params,
        data: request.body,
        responseType: request.responseType,
        onUploadProgress: request.onUploadProgress // Include the onUploadProgress callback
    });
}

export {
    fetchToken,
    getAuthenticatedClient
}
